import React from "react";

interface TextChoiceProps {
  question: string;
  options: string[];
  onAnswer: (selectedOption: string) => void;
  correctAnswer?: string;
  selectedOption?: string;
  showFeedback?: boolean;
}

const TextChoice: React.FC<TextChoiceProps> = ({
  question,
  options,
  onAnswer,
  correctAnswer,
  showFeedback = false,
}) => {
  const [selectedOption, setSelectedOption] = React.useState<string | null>(
    null
  );

  const handleOptionClick = (option: string) => {
    onAnswer(option);
    setSelectedOption(option);
  };

  React.useEffect(() => {
    setSelectedOption(null);
  }, [question]);

  const getButtonClasses = (option: string) => {
    const baseClasses =
      "w-full p-4 border-2 rounded-lg text-left focus:outline-none focus:ring-2 focus:ring-[#FFBE37] shadow-sm transition-all duration-300";

    if (!selectedOption) {
      return `${baseClasses} bg-gray-100 text-gray-800 border-gray-300 hover:bg-gray-200 hover:transform hover:-translate-y-0.5 hover:shadow-md`;
    }

    if (showFeedback) {
      if (option === correctAnswer) {
        return `${baseClasses} bg-[#10B981] text-white border-[#059669]`;
      } else if (option === selectedOption && option !== correctAnswer) {
        return `${baseClasses} bg-[#EF4444] text-white border-[#DC2626]`;
      }
    }

    return `${baseClasses} ${
      option === selectedOption
        ? "bg-[#FFBE37] text-white border-[#FFBE37]"
        : "bg-gray-100 text-gray-800 border-gray-300"
    }`;
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl mb-6 font-semibold">{question}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {options.map((option, index) => (
          <button
            key={index}
            onClick={(e) => {
              e.preventDefault();
              handleOptionClick(option);
            }}
            className={getButtonClasses(option)}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TextChoice;
